'use strict';

var isLiteProfile = require('./isLiteProfile');
var isVisible = require('../isVisible');

module.exports = function () {
   return !isLiteProfile.call(this) && isVisible.call(this);
};